<div class="search-block">
      <div class="search-block-input ml-4">
        <div class="input-group">
          <input class="form-control form-control-sm m-input global-search-input" type="text" name="searchkey"
            [(ngModel)]="searchRequestModel.SearchKey" (keyup.enter)="Search()" (keyup)="PartyFirmSearch($event)"
            (keydown)="PartySelected($event)" (focusout)="PartyOutFocus()" autocomplete="off"
            placeholder="Ara: Doküman No, Ettn, Kaynak Id, Cari, VKN/TCKN, Zarf No, Sipariş No"
            title="Enter tuşu ile arama yapabilirsiniz">
          <button (click)="OpenGlobalSearchDetailPopup()" class="btn-global-search-detail" type="button"
            title="Arama Seçenekleri">
            <svg focusable="false" height="24px" viewBox="0 0 24 24" width="24px" style="border: none"
              xmlns="http://www.w3.org/2000/svg">
              <path d="M7 10l5 5 5-5z"></path>
              <path d="M0 0h24v24H0z" fill="none"></path>
            </svg>
          </button>
          <!-- <div class="input-group-append">
        <button class="btn btn-metal" type="button" (click)="Search()" style="color:#000 !important;">
          <i class="la la-search"></i>
        </button>
      </div> -->
        </div>
      </div>
      <div #search_party_list class="search_party_list" *ngIf="partyList.length > 0">
        <div class="search_party_list_outer_div">
          <div class="search_party_list_inner_div">
            <div class="search_party_item search_party_item_sub_string"
              [style.width.px]="search_party_list.offsetWidth - 25" *ngFor="let party of partyList; let i = index"
              title="{{party.Label}}" [class.search_party_item_hover]="i === 0" (click)="PartySelectedInList(party)">
              {{party.Label}} </div>
          </div>
        </div>
      </div>
      <div class="search-block-popup">
        <div class="m-portlet__body">
          <div class="form-group m-form__group row_original">
            <label class="col-md-2 col-form-label" style="padding: 12px"> Tarih Aralığı </label>
            <div class="col-md-10">
              <div class="m-input-icon date form_datetime bs-datetime m-input-icon--left m-input-icon--right">
                <input class="form-control form-control-sm m-input" name="searchRequestModelIssueDate"
                  (bsValueChange)="DatePickerChange($event)" bsDaterangepicker #DocumentDateRange
                  [bsConfig]="{ rangeInputFormat: 'DD.MM.YYYY', containerClass: 'theme-red' }" readonly
                  placeholder="Tarih Seçiniz..." placement="bottom">
                <span class="m-input-icon__icon m-input-icon__icon--left dateIcon">
                  <span>
                    <i class="la la-calendar"></i>
                  </span>
                </span>
                <span class="m-input-icon__icon m-input-icon__icon--right dateNowIcon">
                  <span class="btn default" (click)="DatePickerChange(null, true)" title="Bugün">
                    <i class="fa fa-calendar-check-o"></i>
                  </span>
                </span>
                <span class="m-input-icon__icon m-input-icon__icon--right dateResetIcon">
                  <span class="btn default" (click)="DatePickerChange(null)" title="Temizle">
                    <i class="la la-times-circle"></i>
                  </span>
                </span>
              </div>
            </div>
          </div>
          <div class="form-group m-form__group row_original" style="border-bottom: 1px solid #afafaf;">
            <label class="col-md-12 col-form-label m--font-bolder" style="padding: 12px"> Aranacak Dokümanlar </label>
          </div>
          <div class="form-group m-form__group row_original">
            <div class="col-md-3" style="padding-top: 8px;">
              <label class="m-checkbox" style="padding-top: 6px;" *ngIf="documentTypeAuthorizedModel.OutgoingInvoice">
                <input type="checkbox" [(ngModel)]="searchRequestModel.SearchOutgoingInvoice"> Giden Fatura
                <span></span>
              </label>
            </div>
            <div class="col-md-3" style="padding-top: 8px;">
              <label class="m-checkbox" style="padding-top: 6px;"
                *ngIf="documentTypeAuthorizedModel.OutgoingDespatchAdvice">
                <input type="checkbox" [(ngModel)]="searchRequestModel.SearchOutgoingDespatchAdvice"> Giden İrsaliye
                <span></span>
              </label>
            </div>
            <div class="col-md-3" style="padding-top: 8px;">
              <label class="m-checkbox" style="padding-top: 6px;" *ngIf="documentTypeAuthorizedModel.CreditNote">
                <input type="checkbox" [(ngModel)]="searchRequestModel.SearchCreditNote"> Müstahsil Makbuzu
                <span></span>
              </label>
            </div>
            <div class="col-md-3" style="padding-top: 8px;">
              <label class="m-checkbox" style="padding-top: 6px;"
                *ngIf="documentTypeAuthorizedModel.MigratedOutgoingInvoice">
                <input type="checkbox" [(ngModel)]="searchRequestModel.SearchMigratedOutgoingInvoice"> Aktarılan Giden
                Fatura <span></span>
              </label>
            </div>
          </div>
          <div class="form-group m-form__group row_original">
            <div class="col-md-3" style="padding-top: 8px;">
              <label class="m-checkbox" style="padding-top: 6px;" *ngIf="documentTypeAuthorizedModel.IncomingInvoice">
                <input type="checkbox" [(ngModel)]="searchRequestModel.SearchIncomingInvoice"> Gelen Fatura
                <span></span>
              </label>
            </div>
            <div class="col-md-3" style="padding-top: 8px;">
              <label class="m-checkbox" style="padding-top: 6px;"
                *ngIf="documentTypeAuthorizedModel.IncomingDespatchAdvice">
                <input type="checkbox" [(ngModel)]="searchRequestModel.SearchIncomingDespatchAdvice"> Gelen İrsaliye
                <span></span>
              </label>
            </div>
            <div class="col-md-3" style="padding-top: 8px;">
              <label class="m-checkbox" style="padding-top: 6px;" *ngIf="documentTypeAuthorizedModel.ESMM">
                <input type="checkbox" [(ngModel)]="searchRequestModel.SearchSMM"> Serbest Meslek Makbuzu <span></span>
              </label>
            </div>
            <div class="col-md-3" style="padding-top: 8px;">
              <label class="m-checkbox" style="padding-top: 6px;"
                *ngIf="documentTypeAuthorizedModel.MigratedIncomingInvoice">
                <input type="checkbox" [(ngModel)]="searchRequestModel.SearchMigratedIncomingInvoice"> Aktarılan Gelen
                Fatura <span></span>
              </label>
            </div>
          </div>
          <div class="form-group m-form__group row_original">
            <div class="col-md-3" style="padding-top: 8px;">
              <label class="m-checkbox" style="padding-top: 6px;"
                *ngIf="documentTypeAuthorizedModel.MyCustomIncomingInvoice">
                <input type="checkbox" [(ngModel)]="searchRequestModel.SearchMyCustomIncomingInvoice"> Faturalarım
                <span></span>
              </label>
            </div>
            <div class="col-md-3" style="padding-top: 8px;">
              <label class="m-checkbox" style="padding-top: 6px;"
                *ngIf="documentTypeAuthorizedModel.MyCustomIncomingDespatchAdvice">
                <input type="checkbox" [(ngModel)]="searchRequestModel.SearchMyCustomIncomingDespatchAdvice">
                İrsaliyelerim <span></span>
              </label>
            </div>
          </div>
          <div class="form-group m-form__group row_original">
            <div class="col-md-3" style="padding-top: 8px;">
              <label class="m-checkbox" style="padding-top: 6px;" *ngIf="documentTypeAuthorizedModel.EarchiveInvoice">
                <input type="checkbox" [(ngModel)]="searchRequestModel.SearchEArchiveInvoice"> E-Arşiv Fatura
                <span></span>
              </label>
            </div>
          </div>
          <div class="row_original">
            <div class="col-md-6" style="text-align: left;">
              <button class="btn btn-link" type="button" (click)="SelectAllDocument(true)"> Tümünü Seç </button> -
              <button class="btn btn-link" type="button" (click)="SelectAllDocument(false)"> Tümünü Kaldır </button>
            </div>
            <div class="col-md-6" style="text-align: right;">
              <button class="btn btn-success" type="button" (click)="Search()">
                <i class="la la-search"></i> Ara </button>
              <button class="btn btn-warning" type="button" (click)="Clear()">
                <i class="la la-eraser"></i> Temizle </button>
              <button class="btn btn-danger" type="button" (click)="CloseGlobalSearchDetailPopup()">
                <i class="la la-close"></i> Kapat </button>
            </div>
          </div>
        </div>
      </div>
    </div>
<!--begin::Modal MessageComponent-->
<MessageVBT #messageVbt></MessageVBT>
<!--end::Modal MessageComponent-->